import { IconButton as UnionIconButton } from '@xo-union/tk-component-icons';
import { IconName } from '@xo-union/dist-iconography';
import React, { SyntheticEvent } from 'react';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: (e: SyntheticEvent<Element, Event>) => void;
  name: IconName;
  expanded?: boolean;
  ariaHasPopup?: boolean;
  text?: string;
  icon?: string;
  className?: string;
  datatestid: string;
  arialabel: string;
  size?: 'sm' | 'md' | 'lg' | undefined;
  ref?: any;
}

export const IconButton: React.FC<Props> = ({ name, ...rest }) => {
  return (
    <UnionIconButton
      name={name}
      className={rest.className}
      data-testid={rest.datatestid}
      aria-label={rest.arialabel}
      aria-haspopup={rest.ariaHasPopup || false}
      aria-expanded={rest.expanded}
      size={rest.size}
      {...rest}
    />
  );
};
